import React, { useEffect, useState } from "react";
import { getCoachingTopics } from "../../Services/coaching";
import { findYourElementsTopic, PLATFORM } from "../../Utils/topicAction";
import "./styles.css";

/**
 * YourElementsEntryButton — dashboard CTA box that opens the Your Elements modal.
 * Renders only when the coaching-topics API includes a navigation-typed topic
 * with target.value === "/elements". This keeps the FE from hardcoding the
 * label/visibility of "Your Elements" — the backend owns it.
 *
 * Props:
 * - onClick: required handler invoked when the button is tapped
 * - sessionType: 'voice' | 'keyboard' (forwarded to getCoachingTopics for cache key parity)
 * - className: extra class applied to the button (e.g. 'keyboard-mode')
 */
const YourElementsEntryButton = ({ onClick, sessionType = "voice", className = "" }) => {
  const [topic, setTopic] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const data = await getCoachingTopics(PLATFORM, sessionType);
        if (cancelled) return;
        const found = findYourElementsTopic(data?.categories);
        setTopic(found?.topic || null);
      } catch (_) {
        // Topic list unavailable — hide the button silently
      }
    })();
    return () => { cancelled = true; };
  }, [sessionType]);

  if (!topic) return null;

  // Inherit the proven visual styling from the existing Quick Session Topics
  // button so both entries look identical regardless of which page renders them.
  const classes = [
    "quick-coaching-topics-btn",
    "your-elements-btn",
    className,
  ].filter(Boolean).join(" ");

  return (
    <button
      type="button"
      className={classes}
      onClick={onClick}
    >
      {topic.title || "Your Elements"}
    </button>
  );
};

export default YourElementsEntryButton;
